// extracted by mini-css-extract-plugin
module.exports = {"container":"delete-playlist_container__rmBio","skeleton_animate":"delete-playlist_skeleton_animate__dRFTr","loading-roller":"delete-playlist_loading-roller__Cnkvc"};